// Bump this string whenever the Assist Program Agreement copy changes.
// Server validates the submitted version against the current one at signup.
export const CURRENT_ASSIST_TERMS_VERSION = '1.0';

// Public URL where the Assist Program Agreement is hosted. Served as a static
// file from public/assist-agreement.html. Update if legal relocates the document.
export const ASSIST_AGREEMENT_URL = '/assist-agreement.html';
